module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sms text-dark no-print text-dark"
  }, [(!_vm.isOpen) ? _c('div', {
    staticClass: "sms-header__toggler",
    on: {
      "click": function($event) {
        return _vm.setOpen(!_vm.isOpen)
      }
    }
  }, [_c('h4', [_vm._v(_vm._s(_vm.i18n[_vm.locale]['send_message']))]), _vm._v(" "), _c('div', {
    staticClass: "close-icon sms-header__toggler__icon text-white"
  }, [(_vm.isOpen) ? _c('span', {
    staticClass: "icon-cross2"
  }) : _c('span', {
    staticClass: "icon-arrow-up4"
  })])]) : _vm._e(), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "slideInUp"
    },
    on: {
      "after-enter": _vm.onEnterComplete
    }
  }, [(_vm.isOpen) ? _c('div', {
    staticClass: "sms-container"
  }, [_c('div', {
    staticClass: "sms-header__toggler",
    on: {
      "click": function($event) {
        _vm.isOpen = !_vm.isOpen
      }
    }
  }, [_c('h4', [_vm._v(_vm._s(_vm.i18n[_vm.locale]['send_message']))]), _vm._v(" "), _c('div', {
    staticClass: "close-icon sms-header__toggler__icon text-white"
  }, [(_vm.isOpen) ? _c('span', {
    staticClass: "icon-cross2"
  }) : _c('span', {
    staticClass: "icon-arrow-up4"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "sms-body"
  }, [_c('transition', {
    attrs: {
      "name": "fadeOut"
    }
  }, [(_vm.noNumberForUser) ? _c('div', {
    staticClass: "sms-body__signup"
  }, [_c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    staticClass: "sms-body__signup__content box"
  }, [_c('h2', {
    staticClass: "text-blue"
  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['welcome_to_sms']))]), _vm._v(" "), _c('p', {
    staticClass: "marg-10-bottom"
  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['add_your_number_to_send_sms']))]), _vm._v(" "), _c('label', [_vm._v(_vm._s(_vm.i18n[_vm.locale]['add_your_number']))]), _vm._v("\n                " + _vm._s(_vm.user.phone) + "\n                "), _c('SmsAddNumber', {
    staticClass: "marg-10-right",
    attrs: {
      "userid": _vm.user.id,
      "updateThisUser": true,
      "isEditFromStart": true
    }
  })], 1)])], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "select-users"
  }, [_c('div', {
    staticClass: "users-header-second users-header-second__button"
  }, [_c('button', {
    staticClass: "do-bttn do-bttn--small",
    on: {
      "click": _vm.getSubsOfTheDay
    }
  }, [_vm._v("\n              " + _vm._s(_vm.i18n[_vm.locale]['todays_substitutes']) + "\n            ")]), _vm._v(" "), _c('DoFiltersFilter', {
    attrs: {
      "title": '',
      "tags": _vm.tags,
      "selectedTags": _vm.appliedFilters
    },
    on: {
      "select": _vm.toggleTag,
      "clear": _vm.clearAllTags
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchText),
      expression: "searchText"
    }],
    staticClass: "users-header__searchfield",
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('vue2.common.search')
    },
    domProps: {
      "value": (_vm.searchText)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchText = $event.target.value
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "list"
  }, [_c('ul', {
    staticClass: "users-list"
  }, [_c('li', {
    staticClass: "users-user users-user__header"
  }, [(_vm.selectedUsers.length < 1) ? _c('p', {
    staticClass: "text-link",
    on: {
      "click": _vm.setAllUsersSelected
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.$t('vue2.tagging.select_all')) + "\n                ")]) : _c('p', {
    staticClass: "text-link",
    on: {
      "click": _vm.removeAllSelectedUsers
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.$t('vue2.tagging.unselect_all')) + "\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "users-user users-user__header__right"
  }, [(_vm.isSMSActive) ? _c('p', [_vm._v(_vm._s(_vm.i18n[_vm.locale]['sms']))]) : _vm._e(), _vm._v(" "), (_vm.isEmailActive) ? _c('p', [_vm._v(_vm._s(_vm.i18n[_vm.locale]['email']))]) : _vm._e()])]), _vm._v(" "), (_vm.isLoading) ? _c('Loader', {
    attrs: {
      "bg-color": "#fff"
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.isLoading) ? [(_vm.filteredUsers.length < 1) ? _c('p', {
    staticClass: "pad-20"
  }, [_c('i', [_vm._v(_vm._s(_vm.i18n[_vm.locale]['no_users_matches']))])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.filteredUsers), function(user, idx) {
    return _c('li', {
      key: user.id,
      ref: 'user_ ' + user.id,
      refInFor: true,
      staticClass: "users-user",
      class: [{
          'users-user--only': _vm.filteredUsers.length === 1
        },
        {
          'isSelected': _vm.checkIfInList(user.id)
        },
        {
          'user--has-no-active-contact': user.v_phone_setting !== 'active' && user.v_email_setting !== 'active'
        },
        {
          'selectedWithoutContactForm': _vm.checkIfInListWithoutContactForm(user.id)
        }
      ]
    }, [_c('div', {
      staticClass: "users-user__meta",
      on: {
        "click": function($event) {
          return _vm.setUser(user, idx, $event)
        }
      }
    }, [_c('div', {
      staticClass: "users-choose",
      class: {
        'users-choose--disabled': user.v_phone_setting !== 'active' && user.v_email_setting !== 'active'
      }
    }, [_c('div', {
      staticClass: "checkbox",
      class: {
        'checkboxChecked': _vm.checkIfInList(user)
      }
    }, [_c('span', {
      staticClass: "checked"
    })])]), _vm._v(" "), _c('div', {
      staticClass: "users-img"
    }, [_c('img', {
      attrs: {
        "src": user.img
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "users-name"
    }, [_c('p', [_vm._v(_vm._s(user.name))])])]), _vm._v(" "), _c('div', {
      staticClass: "users-last"
    }, [_c('div', {
      staticClass: "contact-options"
    }, [(_vm.isSMSActive) ? _c('div', {
      staticClass: "contact-options__option",
      class: {
        'contact-options__option--disabled': user.v_phone_setting === 'deactivated'
      }
    }, [_c('div', {
      directives: [{
        name: "tippy",
        rawName: "v-tippy",
        value: ({
          arrow: true
        }),
        expression: "{\n                             arrow: true\n                           }"
      }],
      staticClass: "icon__bg-circle contact-options__option__phone",
      attrs: {
        "content": user.v_phone_tooltip
      },
      on: {
        "click": function($event) {
          return _vm.setOption(user, 'phone')
        }
      }
    }, [(user.v_phone_setting === 'no_number') ? _c('svg', {
      staticClass: "d-hero-icon--add w-6 h-6",
      attrs: {
        "xmlns": "http://www.w3.org/2000/svg",
        "fill": "none",
        "viewBox": "0 0 24 24",
        "stroke-width": "1.5",
        "stroke": "currentColor"
      }
    }, [_c('path', {
      attrs: {
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        "d": "M12 4.5v15m7.5-7.5h-15"
      }
    })]) : _vm._e(), _vm._v(" "), (user.v_phone_setting === 'active' || user.v_phone_setting === 'deactivated') ? _c('svg', {
      staticClass: "d-hero-icon w-6 h-6",
      class: {
        'd-tw-icon--deactivated': user.v_phone_setting === 'deactivated'
      },
      attrs: {
        "xmlns": "http://www.w3.org/2000/svg",
        "fill": "none",
        "viewBox": "0 0 24 24",
        "stroke-width": "1.5",
        "stroke": "currentColor"
      }
    }, [_c('path', {
      attrs: {
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        "d": "M8.625 9.75a.375.375 0 11-.75 0 .375.375 0 01.75 0zm0 0H8.25m4.125 0a.375.375 0 11-.75 0 .375.375 0 01.75 0zm0 0H12m4.125 0a.375.375 0 11-.75 0 .375.375 0 01.75 0zm0 0h-.375m-13.5 3.01c0 1.6 1.123 2.994 2.707 3.227 1.087.16 2.185.283 3.293.369V21l4.184-4.183a1.14 1.14 0 01.778-.332 48.294 48.294 0 005.83-.498c1.585-.233 2.708-1.626 2.708-3.228V6.741c0-1.602-1.123-2.995-2.707-3.228A48.394 48.394 0 0012 3c-2.392 0-4.744.175-7.043.513C3.373 3.746 2.25 5.14 2.25 6.741v6.018z"
      }
    })]) : _vm._e(), _vm._v(" "), (user.v_phone_setting === 'awaiting_approval') ? _c('svg', {
      staticClass: "w-6 h-6 d-icon__awaiting-approval d-hero-icon",
      attrs: {
        "xmlns": "http://www.w3.org/2000/svg",
        "fill": "none",
        "viewBox": "0 0 24 24",
        "stroke-width": "1.5",
        "stroke": "currentColor"
      }
    }, [_c('path', {
      attrs: {
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        "d": "M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126zM12 15.75h.007v.008H12v-.008z"
      }
    })]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.isEmailActive) ? _c('div', {
      staticClass: "contact-options__option",
      class: {
        'contact-options__option--disabled': user.v_email_setting === 'deactivated'
      }
    }, [_c('div', {
      directives: [{
        name: "tippy",
        rawName: "v-tippy",
        value: ({
          arrow: true
        }),
        expression: "{\n                             arrow: true\n                           }"
      }],
      staticClass: "icon__bg-circle",
      attrs: {
        "content": user.v_email_tooltip
      },
      on: {
        "click": function($event) {
          return _vm.setOption(user, 'email')
        }
      }
    }, [(user.v_email_setting === 'no_email') ? _c('svg', {
      staticClass: "d-hero-icon--add w-6 h-6",
      attrs: {
        "xmlns": "http://www.w3.org/2000/svg",
        "fill": "none",
        "viewBox": "0 0 24 24",
        "stroke-width": "1.5",
        "stroke": "currentColor"
      }
    }, [_c('path', {
      attrs: {
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        "d": "M12 4.5v15m7.5-7.5h-15"
      }
    })]) : _vm._e(), _vm._v(" "), (user.v_email_setting === 'active' || user.v_email_setting === 'deactivated') ? _c('svg', {
      staticClass: "w-6 h-6",
      class: {
        'd-tw-icon--deactivated': user.v_email_setting === 'deactivated'
      },
      attrs: {
        "xmlns": "http://www.w3.org/2000/svg",
        "fill": "none",
        "viewBox": "0 0 24 24",
        "stroke-width": "1.5",
        "stroke": "currentColor"
      }
    }, [_c('path', {
      attrs: {
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        "d": "M21.75 6.75v10.5a2.25 2.25 0 01-2.25 2.25h-15a2.25 2.25 0 01-2.25-2.25V6.75m19.5 0A2.25 2.25 0 0019.5 4.5h-15a2.25 2.25 0 00-2.25 2.25m19.5 0v.243a2.25 2.25 0 01-1.07 1.916l-7.5 4.615a2.25 2.25 0 01-2.36 0L3.32 8.91a2.25 2.25 0 01-1.07-1.916V6.75"
      }
    })]) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "contact-options__option contact-options__option__settings"
    }, [_c('div', {
      staticClass: "icon__bg-circle icon-more2",
      on: {
        "click": function($event) {
          _vm.theActiveEditUser = user
        }
      }
    })])])])])
  })] : _vm._e()], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "send-sms"
  }, [_c('div', {
    staticClass: "users-header-second"
  }, [_c('h2', [_vm._v(_vm._s(_vm.i18n[_vm.locale]['send_message_to']) + " " + _vm._s(_vm.selectedUsers.length))])]), _vm._v(" "), _c('div', {
    staticClass: "send-sms__body"
  }, [_c('div', {
    staticClass: "send-sms__body__templates"
  }, [_c('label', [_vm._v(_vm._s(_vm.i18n[_vm.locale]['select_a_standard_template']))]), _vm._v(" "), (_vm.isLoadingTemplates) ? _c('div', [_c('spinner', {
    attrs: {
      "isSmall": true
    }
  })], 1) : _vm._l((_vm.templates), function(template) {
    return _c('div', {
      key: template.id,
      staticClass: "standard-sms flex"
    }, [_c('div', {
      staticClass: "standard-sms__sub sms-template"
    }, [_c('div', {
      staticClass: "sms-template__title",
      on: {
        "click": function($event) {
          return _vm.selectTemplate(template)
        }
      }
    }, [_c('span', {
      staticClass: "icon-file-text"
    }), _vm._v(" "), _c('p', [_vm._v(_vm._s(template.title))])]), _vm._v(" "), _c('d-dropdown', [_c('ul', {
      attrs: {
        "slot": "list"
      },
      slot: "list"
    }, [_c('li', {
      on: {
        "click": function($event) {
          if ($event.target !== $event.currentTarget) { return null; }
          return _vm.setTheEditTemplate(template)
        }
      }
    }, [_vm._v(_vm._s(_vm.$t('vue2.common.edit')))]), _vm._v(" "), _c('li', {
      staticClass: "d-item-warning",
      on: {
        "click": function($event) {
          if ($event.target !== $event.currentTarget) { return null; }
          _vm.theDeleteTemplate = template
        }
      }
    }, [_vm._v("\n                        " + _vm._s(_vm.$t('vue2.common.delete')) + "\n                      ")])])])], 1)])
  }), _vm._v(" "), _c('div', {
    staticClass: "standard-sms flex"
  }, [_c('div', {
    staticClass: "standard-sms__sub sms-template sms-template__create",
    on: {
      "click": function($event) {
        _vm.isCreateTemplate = true
      }
    }
  }, [_c('div', {
    staticClass: "sms-template__title"
  }, [_c('span', [_vm._v("+")]), _vm._v(" "), _c('p', [_vm._v(" " + _vm._s(_vm.i18n[_vm.locale]['create_a_standard_template']))])])])])], 2), _vm._v(" "), _c('div', {
    staticClass: "send-sms__body__message"
  }, [_c('label', [_vm._v(_vm._s(_vm.i18n[_vm.locale]['message']))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.messageSubject),
      expression: "messageSubject"
    }],
    attrs: {
      "type": "text",
      "placeholder": _vm.i18n[_vm.locale]['subject']
    },
    domProps: {
      "value": (_vm.messageSubject)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.messageSubject = $event.target.value
      }
    }
  }), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.messageBody),
      expression: "messageBody"
    }],
    ref: "sms",
    staticClass: "marg-1-bottom marg-1-top",
    class: {
      'error-class': _vm.giveFeedback && _vm.noText
    },
    attrs: {
      "placeholder": _vm.i18n[_vm.locale]['message']
    },
    domProps: {
      "value": (_vm.messageBody)
    },
    on: {
      "click": function($event) {
        _vm.giveFeedback = false
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.messageBody = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.giveFeedback && _vm.noText) ? _c('span', {
    staticClass: "error-text"
  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['message_must_be_filled']))]) : _vm._e(), _vm._v(" "), (_vm.noText || _vm.noReceiver) ? _c('button', {
    staticClass: "submit-button width-100 submit-button--disabled",
    on: {
      "click": function($event) {
        _vm.giveFeedback = true
      }
    }
  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['send_message']) + "\n              ")]) : _c('button', {
    staticClass: "submit-button width-100",
    on: {
      "click": _vm.sendMessage
    }
  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['send_message']) + "\n              ")])]), _vm._v(" "), _c('div', {
    staticClass: "send-sms__body__receivers marg-1-left marg-1-right"
  }, [_c('label', [_vm._v(_vm._s(_vm.i18n[_vm.locale]['recipients']))]), _vm._v(" "), (_vm.selectedUsers.length < 1) ? _c('p', {
    staticClass: "explainer-text"
  }, [_vm._v("\n                " + _vm._s(_vm.i18n[_vm.locale]['select_recipients']))]) : _vm._e(), _vm._v(" "), _c('ul', {
    staticClass: "receivers-container"
  }, _vm._l((_vm.userSetSelected), function(user) {
    return _c('li', {
      staticClass: "receivers-container__receiver"
    }, [_c('div', {
      staticClass: "receiver__name"
    }, [_vm._v(_vm._s(user.name))]), _vm._v(" "), _c('div', {
      staticClass: "receiver__remove icon-cross2",
      on: {
        "click": function($event) {
          return _vm.setUser(user, _vm.idx)
        }
      }
    })])
  }), 0)])])])], 1)]) : _vm._e()]), _vm._v(" "), (_vm.isCreateTemplate) ? _c('TemplateModal', {
    attrs: {
      "editsms": _vm.theEditTemplate,
      "messageType": "email"
    },
    on: {
      "close": _vm.closeTemplate,
      "updated": _vm.readMessageTemplates
    }
  }) : _vm._e(), _vm._v(" "), (_vm.theDeleteTemplate) ? _c('TemplateDelete', {
    attrs: {
      "editsms": _vm.theDeleteTemplate
    },
    on: {
      "close": function($event) {
        _vm.theDeleteTemplate = null
      },
      "updated": _vm.readMessageTemplates
    }
  }) : _vm._e(), _vm._v(" "), (_vm.theActiveEditUser) ? _c('SendMessagesUserSetting', {
    attrs: {
      "user": _vm.theActiveEditUser,
      "isEmailActive": _vm.isEmailActive,
      "isSMSActive": _vm.isSMSActive
    },
    on: {
      "close": _vm.closeUserSetting
    }
  }) : _vm._e(), _vm._v(" "), (_vm.theActiveEditUser) ? _c('div', {
    staticClass: "bg-overlay"
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-bc5396c8!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SMS/sms.vue
// module id = 1734
// module chunks = 1